/**
 * The possible battery levels
 */
export enum BATTERY_LEVEL {
    UNKNOWN,
    ERROR,
    LOW,
    OK,
    GOOD,
    FULL,
}

/**
 * The voltage levels for Gen4 devices
 * version: 4.*.*.*
 */
export const GEN4_VOLTAGE_LEVELS = [
    {
        max: 6,
        level: BATTERY_LEVEL.ERROR,
    },
    {
        max: 7.5,
        level: BATTERY_LEVEL.LOW,
    },
    {
        max: 8.0,
        level: BATTERY_LEVEL.OK,
    },
    {
        max: 9.0,
        level: BATTERY_LEVEL.GOOD,
    },
    {
        max: 10.0,
        level: BATTERY_LEVEL.FULL,
    },
];
/**
 *
 * The voltage levels for Block devices (with 9volt batteries)
 * version: 3.block.*.*.*
 */
export const SPROUT_VOLTAGE_LEVELS_BLOCK = [
    {
        max: 6,
        level: BATTERY_LEVEL.ERROR,
    },
    {
        max: 7.5,
        level: BATTERY_LEVEL.LOW,
    },
    {
        max: 8.0,
        level: BATTERY_LEVEL.OK,
    },
    {
        max: 9.0,
        level: BATTERY_LEVEL.GOOD,
    },
    {
        max: 10.0,
        level: BATTERY_LEVEL.FULL,
    },
];
/**
 *
 * The voltage levels for micro devices (with 2*AA batteries)
 * version: 3.micro.*.*.*
 *
 * Values here are taken from the AA spec sheet and multiplied by 2 to account for the two batteries
 */
export const SPROUT_VOLTAGE_LEVELS_MICRO = [
    {
        max: 1.5 * 2,
        level: BATTERY_LEVEL.ERROR,
    },
    {
        max: 1.55 * 2,
        level: BATTERY_LEVEL.LOW,
    },
    {
        max: 1.6 * 2,
        level: BATTERY_LEVEL.OK,
    },
    {
        max: 1.65 * 2,
        level: BATTERY_LEVEL.GOOD,
    },
    {
        max: 1.7 * 2,
        level: BATTERY_LEVEL.FULL,
    },
];

/**
 * The battery percent levels for the Seed device stats
 * version: 1.*.*.*.*
 */
export const SEED_DEVICE_STATS_BATTERY_LEVELS = [
    {
        max: 1.3,
        level: BATTERY_LEVEL.ERROR,
    },
    {
        max: 1.4,
        level: BATTERY_LEVEL.LOW,
    },
    {
        max: 1.6,
        level: BATTERY_LEVEL.OK,
    },
    {
        max: 1.7,
        level: BATTERY_LEVEL.FULL,
    },
];
